import axios from 'axios'
import store from '@/store'
import { getXAuthToken, getXAuthAgent } from '@/utils/auth'
import VueSimpleAlert from "vue-simple-alert";

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

        // if (store.getters.token) {
        //     // let each request carry token

        //     config.headers['Authorization'] = 'Bearer ' + getToken()
        // } else {
        //     config.headers['Authorization'] = getAuthorization()
        // }
        if (store.getters.x_auth_token != "") {
            // let each request carry token
            config.headers['X-Auth-Token'] = 'Bearer ' + store.getters.x_auth_token
        } else if (getXAuthToken() != "" && getXAuthToken() != null) {
            config.headers['X-Auth-Token'] = "Bearer " + getXAuthToken()
        }

        if (store.getters.x_auth_agent != "") {
            // let each request carry token
            config.headers['X-Auth-Agent'] = 'Bearer ' + store.getters.x_auth_agent
        } else if (getXAuthAgent() != "" && getXAuthAgent() != null) {
            config.headers['X-Auth-Agent'] = "Bearer " + getXAuthAgent()
        }


        // config.headers['Authorization'] = 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiZTk1NWQ0NmItNzUzMi00ZDY2LTg4YTEtZWJiMTg4N2NhZGNjIiwiZXhwIjoxNjM2MDM1MjgxfQ.qdPKlj8nogcpSBMhLDdJlefeMQQJEiSUBXMEz56-R2Uc1BAB-zQG5Q2dNKFjqev1f_vJmgE_psqj9PhKX77PaNKY78g2eDLC2U-0wNxtZ7Kqq1JqpkwAKB6DiFAu5mVCfT-7cTVFRrpFiH-dy3j5JRmVIBjmL-T6o0089MIO8WxJejsNbmp20kQ7ILmt4291uF7A_fd6mdeYEGbsQZdA6RNydqtCmuaYeG7DGDJ3YlUqeK5_6Nmotq5haR630WVDnN5fjgSCa7sS94LerA9OdGL6wrwimJ-oJgAOlV21zgNE21v7nUzBP6m8he4DcYuTvbiU4JlPaO0-NY7VSyOAcQ'

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // const res = response
        // if the custom code is not 20000, it is judged as an error.

        if (res.status !== 200) {
            var errorMsg = res.msg

            if (res.status === 401) {
                store.dispatch('user/resetToken').then(() => {
                    window.location.href = (process.env.BASE_URL) ? process.env.BASE_URL : '/'
                })
            } else {
                if (errorMsg !== undefined) {
                    // alert(errorMsg.replace(/<br\s*\/?>/gi, '\n') || 'Error')
                    // this.$alert(errorMsg.replace(/<br\s*\/?>/gi, '\n'));
                    VueSimpleAlert.alert(errorMsg.replace(/<br\s*\/?>/gi, '\n'));

                }
            }

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.status === 50008 || res.status === 50012 || res.status === 50014) {
                // to re-login

                store.dispatch('user/resetToken').then(() => {
                    location.reload()
                })
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        const errorMsg = error.response.data.msg
        console.log(error) // for debug

        if (error.response.data.status === 401) {
            store.dispatch('user/resetToken').then(() => {
                window.location.href = (process.env.BASE_URL) ? process.env.BASE_URL : '/'
            })
        } else {
            if (errorMsg !== undefined) {
                // alert(errorMsg.replace(/<br\s*\/?>/gi, '\n'))
                VueSimpleAlert.alert(errorMsg.replace(/<br\s*\/?>/gi, '\n'));

            }
        }

        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js